import { useEffect, useContext } from 'preact/hooks';

import GlobalContext from '../context/GlobalContext.js';

const Analytics = ({ pageType, pageFamilyName }) => {
  const { enableanalytics } = useContext(GlobalContext);
  useEffect(() => {
    if (import.meta.env.VITE_ADOBE_ANALYTICS_ENABLED === 'true' && enableanalytics === 'true') {
      if (typeof window !== 'undefined' && window._satellite) {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: 'V7',
            coBrandedVersion: 'Bespoke Light',
          },
          page: {
            pageType: pageType,
            pageFamilyName: pageFamilyName,
          },
        }
        try {
          _satellite.track('pageView');
        } catch (e) {
          console.error(e)
        }
      }
    }
  }, [pageType, pageFamilyName]);

  return null;
};

export default Analytics;
